import articleDeliveryStatuses from "astrid-firestore/src/api/articles/constants/articleDeliveryStatuses";
import { useDocumentData } from "astrid-firestore/src/hooks";

import { getPipelineProgressPercentage } from "../../pipelines/utils/pipelineProgress";

import useArticleDeliveryStatuses from "./useArticleDeliveryStatuses";

export default function useArticleDeliveryStatus(deliveryType, { article, channel }) {
	const { delivery } = article.channels?.[channel?.id] || article;

	const deliveryData = delivery?.[deliveryType];

	const { status = articleDeliveryStatuses.DELIVERY_NOT_STARTED, distribution } = deliveryData || {};

	const { text, color, active, disabled } = useArticleDeliveryStatuses(deliveryData)[status];

	const subscribe = !!distribution?.ref && status === articleDeliveryStatuses.DELIVERY_IN_PROGRESS;

	const [data] = useDocumentData(subscribe && distribution?.ref.collection("progress").doc("progressDoc"));

	const percent = getPipelineProgressPercentage(data?.progress);

	const date = getDeliveryStatusDate({ delivery, deliveryType, status });

	return { percent, date, status: text, color, active, disabled };
}

function getDeliveryStatusDate({ delivery, deliveryType, status }) {
	switch (status) {
		case articleDeliveryStatuses.DELIVERY_COMPLETED:
			return delivery?.[deliveryType]?.sent?.toDate?.()?.toLocaleString();

		case articleDeliveryStatuses.DELIVERY_PENDING:
			return delivery?.[deliveryType]?.distribution?.scheduledAt?.toDate?.()?.toLocaleDateString();

		default:
			return null;
	}
}
